import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useMemo, useState } from 'react';
import { ComponentMode } from '../../../types';
import DetailCard from '../../../v2/components/generic/ObjectView/DetailCard/DetailCard';
import { getViewDefinitionFromUserAttributes } from '../../factories/AttributeDefinitions';
/**
 * # DO NOT USE
 *
 * This component _only_ exists for viewing and analysis in the `WIDGET_PLAYGROUND`
 */
export const DetailCardWidget = (props) => {
    const { user } = props;
    const [viewDefinition, setViewDefinition] = useState();
    useEffect(() => {
        if (user && !viewDefinition) {
            const attributes = user.getUserAttributes();
            const viewDefinition = getViewDefinitionFromUserAttributes(attributes);
            setViewDefinition(viewDefinition);
        }
    }, [user]);
    const component = useMemo(() => user && viewDefinition ? (_jsx(DetailCard, { matchedPrimary: user, mostProximateCustomer: undefined, viewDefinition: viewDefinition, transactionFunctions: props.transactionFunctions, userFunctions: props.userFunctions, editMode: ComponentMode.EDIT })) : (_jsx(_Fragment, {})), [user, viewDefinition]);
    return {
        name: 'DetailCard',
        category: 'composite',
        component,
    };
};
